import { Aviso, Cabecalho, Celula, CelulaCabecalho, Corpo, Linha, Tabela } from "../componentes/ui";
import { podeNaSessao, useSessao } from "../nucleo/sessao";
import { useTitulo } from "../nucleo/titulo";

/**
 * Financeiro no portal do cliente (requisito 5 da Amanda, 01/10/2026; protótipo, tela 16).
 *
 * **Estado vazio honesto.** Os títulos são as faturas do cliente com a GEOvendas, e essa
 * informação não está no Jira nem no portal: vive em outro sistema, "ainda a identificar" — o
 * levantamento da fonte é tarefa do desenvolvimento. Por isso a tela mostra as colunas que o
 * protótipo promete (competência, vencimento, valor, situação, documentos) sem uma única linha
 * inventada, e diz por que está vazia. Nada de "Em dia" nem de valor: um selo de adimplência
 * sem dado por trás é pior que tela vazia.
 *
 * Duas decisões do protótipo continuam abertas e dependem da fonte: quem a equipe sugere por
 * padrão ao convidar, e o que aparece quando o cliente está inadimplente.
 *
 * Visibilidade por usuário: `financeiro:ver` é a tela "Financeiro" da matriz de acesso (perfil
 * mais o ajuste por pessoa). O menu esconde o item de quem não a tem; a tela repete a conferência
 * para quem digita o endereço.
 */
export function FinanceiroDoCliente() {
  useTitulo("Financeiro");
  const sessao = useSessao();

  if (!podeNaSessao(sessao.data, "financeiro:ver")) {
    return (
      <div data-testid="financeiro-do-cliente">
        <h1 className="titulo-pagina">Financeiro</h1>
        <Aviso tom="marca" data-testid="financeiro-sem-permissao">
          <b>O seu acesso não inclui o financeiro.</b> Quem administra o acesso da sua empresa pode
          liberá-lo.
        </Aviso>
      </div>
    );
  }

  return (
    <div data-testid="financeiro-do-cliente">
      <h1 className="titulo-pagina">Financeiro</h1>
      <p className="lead">
        Segunda via de boleto e notas fiscais do seu contrato com a GEOvendas, sem precisar pedir
        para ninguém. Esta tela é somente de consulta: não há pagamento por aqui.
      </p>

      <Aviso tom="marca" className="mb-4" data-testid="financeiro-indisponivel">
        <b>Os seus títulos ainda não aparecem aqui.</b> Eles vêm do sistema financeiro da
        GEOvendas, e a ligação entre esse sistema e o portal ainda não foi feita. Enquanto isso,
        peça a segunda via ao seu consultor.
      </Aviso>

      <Tabela legenda="Títulos do contrato — ainda sem dados.">
        <Cabecalho>
          <Linha>
            <CelulaCabecalho>Competência</CelulaCabecalho>
            <CelulaCabecalho>Vencimento</CelulaCabecalho>
            <CelulaCabecalho>Valor</CelulaCabecalho>
            <CelulaCabecalho>Situação</CelulaCabecalho>
            <CelulaCabecalho>Documentos</CelulaCabecalho>
          </Linha>
        </Cabecalho>
        <Corpo>
          <Linha>
            <Celula colSpan={5} className="celula-secundaria" data-testid="financeiro-sem-titulos">
              Nenhum título disponível.
            </Celula>
          </Linha>
        </Corpo>
      </Tabela>
    </div>
  );
}
